/* eslint no-loop-func: 0 */
import React, { Component } from 'react'
import moment from 'moment'
import { Grid, Row, Col, Table, FormControl } from 'react-bootstrap'
import NotificationSystem from 'react-notification-system'
import { connect } from 'react-redux'
import Select from 'react-select'
import Card from '../../components/Card/Card'
import { style } from '../../variables/Variables'

const API_SERVER = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : '..'
const API_INGENIOUS = API_SERVER + '/ig/masterdata'

function format (value) {
  const dotValue = value.replace(',', '.')
  return (Math.round(dotValue * 100) / 100).toFixed(2).replace('.', ',')
}

class ClicksValidation extends Component {
  constructor (props) {
    super(props)
    this.onRequest = props.onRequest
    this.onResponse = props.onResponse
    this.handleSubmit = this.handleSubmit.bind(this)
    const month = moment().format('YYYY-MM')
    this.state = {
      month,
      page: 0,
      query: '',
      disabledPrevButton: true,
      disabledNextButton: false,
      advertisers: [],
      partners: [],
      adspaces: [],
      currency: 'PLN',
      filtered: false,
      spinner: true
    }
    this.onResponse([])

    if (this.state.filtered === true) {
      this.fetchIGData('key-account-manager', 'accounts')
    }

    setTimeout(() => {
      this.fetchAPI()
      this.loadNext()
    }, 1000)
  }

  fetchIGData (url, stateData) {
    fetch(`${API_INGENIOUS}/${url}`)
      .then(res => res.json())
      .catch((error) => {
        console.error('Error:', error)
      })
      .then((response) => {
        this.setState({ [stateData]: response })
      })
  }

  fetchAPI () {
    let query = ''
    if (this.state.filtered === true) {
      const { user } = this.props
      const { accounts } = this.state
      if (user && (user.UF_DEPARTMENT.indexOf(7) === -1 && user.UF_DEPARTMENT.indexOf(216) === -1)) {
        const loggedAccount = accounts
          ? accounts.filter(item =>
            item.firstName.toLowerCase() === user.NAME.toLowerCase() &&
          item.lastName.toLowerCase() === user.LAST_NAME.toLowerCase())
          : []
        query = loggedAccount[0] && loggedAccount[0].id ? `&filter[where][it.keyAccountManagerId]=${loggedAccount[0].id}` : ''
      }
    }
    fetch(`${API_SERVER}/db/api/clients?filter[where][ITID][exists]=true${query}`)
      .then(res => res.json())
      .catch(error => console.error('Error:', error))
      .then((rawAdvertisers) => {
        const advertisers = rawAdvertisers.filter(advertiser => advertiser && advertiser.ITID && (advertiser.company || '').trim())
        advertisers.sort((a, b) => ((a.company || '').toLowerCase() < (b.company || '').toLowerCase() ? -1 : 1))
        this.setState({ advertisers })
      })
    fetch(`${API_SERVER}/db/api/relationships`)
      .then(res => res.json())
      .catch(error => console.error('Error:', error))
      .then((relationships) => {
        this.setState({ relationships })
      })
    fetch(`${API_SERVER}/db/api/partners?filter[where][ITID][exists]=true`)
      .then(res => res.json())
      .catch(error => console.error('Error:', error))
      .then((rawPartners) => {
        let adspaces = []
        const used = {}
        rawPartners.forEach((partner) => {
          if (partner.adSpacesFromIT) {
            adspaces = adspaces.concat(partner.adSpacesFromIT.map((item) => {
              item.partnerId = partner.ITID
              return item
            }))
          }
        })
        const partners = rawPartners.filter(partner => partner && partner.ITID && (partner.company || '').trim()).filter((item) => {
          const result = !used[item.ITID]
          used[item.ITID] = 1
          return result
        })
        adspaces = adspaces.filter(adspace => adspace)
        partners.sort((a, b) => (a.company.toLowerCase() < b.company.toLowerCase() ? -1 : 1))
        adspaces.sort((a, b) => (a.name < b.name ? -1 : 1))
        this.setState({ fullPartners: partners, fullAdspaces: adspaces.slice() })
      })
  }

  loadNext () {
    const onResponse = this.onResponse
    this.setState({ spinner: true })
    this.onRequest()

    fetch(`${API_SERVER}/q3kzJGaGs9uBaWPJw57CdN4mbWw3Hmp4AyhemjqgeGc5vymdyn/api/clients/report.json?month=${this.state.month}&adspace=false`)
      .then(res => res.json())
      .catch(error => console.error('Error:', error))
      .then((response) => {
        const today = moment().format('YYYY-MM-DD')
        fetch(`${API_SERVER}/db/api/clicks?filter[where][time]=${today}`, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          method: 'GET'
        })
          .then(res => res.json())
          .catch((error) => {
            console.error('Error:', error)
          })
          .then((res) => {
            const clicks = response
            let key
            for (key in clicks) {
              if (res.filter(item =>
                item.advertiserId === `${clicks[key].advertiserId}` &&
                item.partnerId === `${clicks[key].partnerId}` &&
                item.adspaceId === `${clicks[key].adspaceId}`).length > 0) {
                clicks[key].readonly = true
              }
            }
            onResponse(response || [])
            this.setState({ spinner: false })
          })
      })
  }

  changeMonth (month) {
    this.setState({
      month
    })
    this.onResponse([])
    setTimeout(() => {
      this.loadNext()
    }, 1000)
  }

  handleSubmit (event) {
    const path = this.props.match.params.month
    const queryAdd = path === 'add' ? '&add=1' : ''

    const refs = this.refs
    refs.notificationSystem.addNotification({
      title: (<span data-notify='icon' className='pe-7s-cloud-upload' />),
      message: (
        <div>Wysyłanie danych</div>
      ),
      level: 'info',
      position: 'br'
    })

    const params = new FormData(event.target)

    const searchParams = []
    let pair
    for (pair of params.entries()) {
      searchParams.push(`${encodeURIComponent(pair[0])}=${encodeURIComponent(pair[1])}`)
    }

    fetch(`${API_SERVER}/q3kzJGaGs9uBaWPJw57CdN4mbWw3Hmp4AyhemjqgeGc5vymdyn/api/clients/report-save?month=${this.state.month}${queryAdd}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: searchParams.join('&')
    })
      .then(response => response.json())
      .catch((error) => {
        refs.notificationSystem.addNotification({
          title: (<span data-notify='icon' className='pe-7s-bandaid' />),
          message: (
            <div>Wystąpił błąd</div>
          ),
          level: 'error',
          position: 'br'
        })
        console.error('Error:', error)
      })
      .then((response) => {
        if (response.result && response.result.success && response.result.success.length) {
          refs.notificationSystem.addNotification({
            title: (<span data-notify='icon' className='pe-7s-check' />),
            message: (
              <div>Dane zostały zapisane</div>
            ),
            level: 'success',
            position: 'br',
            autoDismiss: 6
          })
        } else {
          refs.notificationSystem.addNotification({
            title: (<span data-notify='icon' className='pe-7s-bandaid' />),
            message: (
              <div>{response.result.error[0].message}</div>
            ),
            level: 'error',
            position: 'br'
          })
        }
      })
    event.preventDefault()
    event.stopPropagation()
    setTimeout(() => {
      this.loadNext()
    }, 1000)
  }

  selectDate () {
    const startDate = moment('2018-04')
    const endDate = moment().subtract(1, 'month')

    const dates = []
    while (endDate > startDate) {
      dates.push(startDate.format('YYYY-MM'))
      startDate.add(1, 'month')
    }

    return (
      <FormControl
        componentClass='select'
        placeholder={moment().format('YYYY-MM')}
        type='select'
        className='btn btn-default'
        value={this.state.month}
        onChange={(e) => {
          this.setState({ month: e.target.value })
          this.changeMonth(e.target.value)
        }}
      >
        <option value={moment().format('YYYY-MM')}>{moment().format('YYYY-MM')}</option>
        {
          dates.reverse().map(item => <option value={item} key={item}>{item}</option>)
        }
      </FormControl>
    )
  }

  selectAdvertiser () {
    let clicks = this.props.clicks ? this.props.clicks : []
    clicks = clicks.filter((value, index, arr) => arr.map(mapObj => mapObj.advertiserId).indexOf(value.advertiserId) === index)
    const options = clicks.map(prop => ({
      value: prop.advertiserId,
      label: `${prop.advertiserName} (${prop.advertiserId})`
    }))

    return (
      <Select
        isClearable
        options={options}
        placeholder='Wybierz reklamodawcę'
        styles={{ control: styles => ({ ...styles, width: 300, marginRight: 5, marginTop: 15, fontSize: 14 }) }}
        onChange={(event) => {
          this.setState({ selectedAdvertiser: event ? event.value : '' })
        }}
      />
    )
  }

  selectPartner () {
    let clicks = this.props.clicks ? this.props.clicks : []
    clicks = clicks.filter((value, index, arr) => arr.map(mapObj => mapObj.partnerId).indexOf(value.partnerId) === index)
    const options = clicks.map(prop => ({
      value: prop.partnerId,
      label: `${prop.partnerName} (${prop.partnerId})`
    }))

    return (
      <Select
        isClearable
        options={options}
        placeholder='Wybierz partnera'
        styles={{ control: styles => ({ ...styles, width: 300, marginRight: 5, marginTop: 15, fontSize: 14 }) }}
        onChange={(event) => {
          this.setState({ selectedPartner: event ? event.value : '' })
        }}
      />
    )
  }

  selectRange () {
    const options = [
      { value: false, label: 'Wszystkie' },
      { value: true, label: 'Tylko moje' }
    ]

    return (
      <Select
        options={options}
        placeholder='Wszystkie'
        styles={{ control: styles => ({ ...styles, width: 150, marginRight: 5, marginTop: 15, fontSize: 14 }) }}
        onChange={() => {
          this.setState({ filtered: !this.state.filtered })
        }}
      />
    )
  }

  tableSum (data) {
    const commissionSum = data.reduce((a, b) => (
      { commission: Number(a.commission) + Number(b.commission) }), { commission: 0 })
    const feeSum = data.reduce((a, b) => (
      { fee: Number(a.fee) + Number(b.fee) }), { fee: 0 })

    return (
      <tr>
        <td colSpan={4}>&nbsp;</td>
        <td className='amount sum'>Suma:</td>
        <td style={{ textAlign: 'right' }}>{commissionSum.commission.toFixed(2).replace('.', ',')}</td>
        <td style={{ textAlign: 'right' }}>{feeSum.fee.toFixed(2).replace('.', ',')}</td>
        <td>&nbsp;</td>
      </tr>
    )
  }

  tableContent () {
    const path = this.props.match.params.month
    if (path !== 'add') {
      let data = this.props.clicks ? this.props.clicks : []

      if (this.state.filtered === true) {
        const { user } = this.props
        const advertisers = this.state.advertisers
        if ((user && (user.UF_DEPARTMENT.indexOf(7) === -1 && user.UF_DEPARTMENT.indexOf(162) === -1))) {
          const datafiltered = []
          if (advertisers && advertisers.length > 0) {
            advertisers.forEach((el) => {
              data.map(item => (el.ITID === item.advertiserId ? datafiltered.push(item) : ''))
            })
            data = datafiltered
          }
        }
      } else {
        console.log('unfiltered')
      }

      if (this.state.selectedAdvertiser) {
        data = data.filter(item => item.advertiserId === this.state.selectedAdvertiser)
      }

      if (this.state.selectedPartner) {
        data = data.filter(item => item.partnerId === this.state.selectedPartner)
      }

      return (
        <tbody>
          {
          data.map((prop, key) => (
            <tr key={`${prop.advertiserId}${prop.partnerId}${key}`}>
              <td>{key + 1}</td>
              <td><span className='sup'>{prop.advertiserId}</span></td>
              <td>{prop.advertiserName}</td>
              <td><span className='sup'>{prop.partnerId}</span></td>
              <td>{prop.partnerName}</td>
              <td style={{ textAlign: 'right' }}>{prop.commission.replace('.', ',')}</td>
              <td style={{ textAlign: 'right' }}>{prop.fee.replace('.', ',')}</td>
              <td style={{ textAlign: 'right' }}>{prop.currencyCode}</td>
            </tr>
          ))
        }
          {this.tableSum(data)}
        </tbody>
      )
    }
    return (
      <tbody>
        <tr>
          <td>&nbsp;</td>
          <td>
            <Select
              name='newAdvertiserId'
              style={{ maxWidth: 200 }}
              onChange={function (event) {
                const value = event.value
                const adSpaces = this.state.relationships.filter(item => item.advertiserId === value).map(item => item.adspaceId)
                const partnerIDs = this.state.fullAdspaces.filter(item => adSpaces.indexOf(item.id) !== -1).map(item => item.partnerId)
                this.setState({
                  newAdvertiserId: value,
                  partners: this.state.fullPartners.filter(item => partnerIDs.indexOf(item.ITID) !== -1)
                })
              }.bind(this)}
              options={this.state.advertisers.map(item => ({ value: item.ITID, label: `${item.company} (${item.ITID})` }))}
            />
          </td>
          <td>
            <Select
              style={{ maxWidth: 200 }}
              onChange={function (event) {
                const value = event.value
                const adSpaces = this.state.relationships.filter(item => item.advertiserId === this.state.newAdvertiserId).map(item => item.adspaceId)
                this.setState({ adspaces: this.state.fullAdspaces.filter(item => item.partnerId === value).filter(item => adSpaces.indexOf(item.id) !== -1) })
              }.bind(this)}
              name='newPartnerId'
              options={this.state.partners.map(item => ({ value: item.ITID, label: `${item.company} (${item.ITID})` }))}
            />
          </td>
          <td><Select
            style={{ maxWidth: 200 }}
            name='newAdspaceId'
            options={this.state.adspaces.map(item => ({ value: item.id, label: `${item.name} (${item.id})` }))}
              />
          </td>
          <td><input
            name='newAdmediaId'
              />
          </td>
          <td><input
            name='newCommission'
            value={this.state.newCommission}
            className='amount'
            onClick={(event) => {
              event.target.select()
            }}
            onBlur={(event) => {
              const value = event.target.value
              this.setState({ newCommission: format(value) })
            }}
            onChange={(event) => {
              const value = event.target.value
              this.setState({ newCommission: value })
            }}
              />
          </td>
          <td><input
            name='newFee'
            value={this.state.newFee}
            className='amount'
            onClick={(event) => {
              event.target.select()
            }}
            onBlur={(event) => {
              const value = event.target.value
              this.setState({ newFee: format(value) })
            }}
            onChange={(event) => {
              const value = event.target.value
              this.setState({ newFee: value })
            }}
              />
          </td>
          <td>
            <FormControl componentClass='select' name='newCurrencyCode' style={{ textAlign: 'right' }}>
              <option>PLN</option>
              <option>USD</option>
              <option>EUR</option>
            </FormControl>
          </td>
        </tr>
      </tbody>
    )
  }

  render () {
    const path = this.props.match.params.month
    return (
      <div className='content'>
        <NotificationSystem ref='notificationSystem' style={style} />
        <form className='form-inline' onSubmit={this.handleSubmit}>
          <Grid fluid>
            <Row>
              <Col md={12}>
                <nav className='navbar navbar-light bg-light'>
                  {this.state.spinner ? <div className='lds-dual-ring' id='spinner' /> : ''}
                  <div role='group' aria-label='Basic example' style={{ display: 'flex' }}>
                    {path === 'add'
                      ? <button
                          className='btn'
                          onClick={() => {
                            this.props.history.push({ pathname: '/clicks-validation/:month' })
                          }}
                        >
                        &lt; powrót do listy
                        </button>
                      : ''}
                    {path !== 'add' ? this.selectDate() : ''}
                    {path !== 'add' ? this.selectAdvertiser() : ''}
                    {path !== 'add' ? this.selectPartner() : ''}
                    {path !== 'add' ? this.selectRange() : ''}
                  </div>
                </nav>
              </Col>
              <Col md={12}>
                <Card
                  title={`Raport klików i odsłon ${this.state.month}`}
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th style={{ width: '3%' }}>#</th>
                          <th style={{ width: '3%' }}>ID</th>
                          <th style={{ width: '27%' }}>Reklamodawca</th>
                          <th style={{ width: '3%' }}>ID</th>
                          <th style={{ width: '27%' }}>Partner</th>
                          <th style={{ width: '17%', textAlign: 'right' }}>Commision</th>
                          <th style={{ width: '17%', textAlign: 'right' }}>Fee</th>
                          <th style={{ width: '3%', textAlign: 'right' }}>Currency</th>
                        </tr>
                      </thead>
                      {this.tableContent()}
                    </Table>
                  }
                />
              </Col>
            </Row>
          </Grid>
        </form>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  clicks: state.clicks,
  user: state.user
})

const mapDispatchToProps = {
  onRequest: () => ({
    type: 'REQUEST_CLICKS'
  }),
  onResponse: clicks => ({
    type: 'SET_CLICKS',
    clicks
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(ClicksValidation)
